import {createSlice} from "@reduxjs/toolkit";
import {ResponseApi} from '../BaseApi';
import {GetGeofenceConfigSettingByGeofenceId, GetGeofenceList} from "./FineGeofenceApi";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

const FineGeofenceSlice = createSlice({
    name: "fineGeofenceSection",
    initialState: {
        getGeofenceList: [],
        geofenceConfig: null
    },
    reducers: {
        resetGetGeofenceList: (state, action) => {
            state.getGeofenceList = [];
        },
    },
    extraReducers: (builder) => {
        builder.
        addCase(GetGeofenceList.fulfilled, (state, {payload}) =>{
            state.getGeofenceList = ResponseApi(payload);
        }).addCase(GetGeofenceConfigSettingByGeofenceId.fulfilled, (state, {payload}) =>{
            state.geofenceConfig = ResponseApi(payload);
        })
    }

})

export const {resetGetGeofenceList } = FineGeofenceSlice.actions;

export default FineGeofenceSlice.reducer;
